import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { MediaSubscription } from '../../../../Monitor/Shared/models/media-subscription.model';
import { MediaSubscriptionMediaTypeEnum } from '../../../../api/mediaSubscriptions/enums/media-subscription-media-type.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-social-search-detail',
    templateUrl: './social-search-detail.component.html',
    styleUrls: ['./social-search-detail.component.scss'],
    animations: [
        trigger('containerState', [
            state('hidden', style({
                opacity: 0,
                height: 0
            })),
            state('visible', style({
                opacity: 1,
                height: '*'
            })),
            transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class SocialSearchDetailComponent {

    @Input() activeSearch: MediaSubscription;

    readonly mediaTypes = MediaSubscriptionMediaTypeEnum;
    readonly buttonTypes = ButtonTypesEnum;

    searchDetailsExpanded: boolean = true;
}
